/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Status_Export_CompleteInputs */

const en_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export complete!`)
};

const fr_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation terminee !`)
};

const de_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgeschlossen!`)
};

const it_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione completata!`)
};

const ru_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт завершен!`)
};

const es_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Exportación completada!`)
};

const zh_cn2_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出完成！`)
};

const ja_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートが完了しました!`)
};

const hi_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूरा हुआ!`)
};

const pt_pt2_image_export_status_export_complete = /** @type {(inputs: Image_Export_Status_Export_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação concluída!`)
};

/**
* | output |
* | --- |
* | "Export complete!" |
*
* @param {Image_Export_Status_Export_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_export_complete = /** @type {((inputs?: Image_Export_Status_Export_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Export_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_status_export_complete(inputs)
	if (locale === "de") return de_image_export_status_export_complete(inputs)
	if (locale === "it") return it_image_export_status_export_complete(inputs)
	if (locale === "ru") return ru_image_export_status_export_complete(inputs)
	if (locale === "es") return es_image_export_status_export_complete(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_status_export_complete(inputs)
	if (locale === "ja") return ja_image_export_status_export_complete(inputs)
	if (locale === "hi") return hi_image_export_status_export_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_status_export_complete(inputs)
	return en_image_export_status_export_complete(inputs)
});